import { apiDelete } from '@/api/api.ts'
import { IUser } from '@/api/user/getUsers.ts'

export const apiDeleteUser = async (id: number) => {
    return await apiDelete<IUser>(`/protectee/${id}`)
}
